import { Component, OnInit } from '@angular/core';
import { Guid } from 'guid-typescript';
import { ModulPrWertFilter } from 'src/app/data/ws/modul/modul-pr-wert-filter.model';
import { FilterWertRowComponent } from '../filter-wert-row/filter-wert-row.component';
import { LocalService } from 'src/app/services/local.service';
import { UserGebaeudeFilter } from 'src/app/data/user/user-gebaeude-filter.model';
import { ValueFormat } from 'globales-projekt-angular';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-filter-wert-tabelle',
  templateUrl: './filter-wert-tabelle.component.html',
  styleUrls: ['./filter-wert-tabelle.component.css'],
})
export class FilterWertTabelleComponent implements OnInit {
  modulPrWertFilter!: ModulPrWertFilter;
  parentMainComponent!: FilterWertRowComponent;
 
  id!: Guid;
  valueFormat: ValueFormat = new ValueFormat();
  selectValueVonFormControl: FormControl = new FormControl(null);
  selectValueBisFormControl: FormControl = new FormControl(null);

  constructor(private localService: LocalService) {}

  ngOnInit(): void {}

  setVariablen(modulPrWertFilter: ModulPrWertFilter) {
    this.modulPrWertFilter = modulPrWertFilter;
    this.selectValueVonFormControl.setValue(modulPrWertFilter.wertPrFilterVonList[0].wert);
    this.selectValueBisFormControl.setValue(modulPrWertFilter.wertPrFilterBisList[  modulPrWertFilter.wertPrFilterBisList.length - 1].wert);
  
  }

  onChangeVon() { 
    this.selectValueBisFormControl.updateValueAndValidity({emitEvent: false});
    this.changeValue();
  }

  onChangeBis() { 
    this.selectValueVonFormControl.updateValueAndValidity({emitEvent: false});
    this.changeValue();
  }

  changeValue() {
    if (this.selectValueVonFormControl.value > this.selectValueBisFormControl.value)
      {
        this.selectValueVonFormControl.setErrors({ pattern: true });
        this.selectValueBisFormControl.setErrors({ pattern: true });
        return;
      }



    let userGebaeudeFilter: UserGebaeudeFilter | null =
      this.localService.userGebaeudeFilter.value;
    let found = false;

    for (let i = 0; i < userGebaeudeFilter!.idModulAuspList.length; i++) {
      if (
        userGebaeudeFilter!.idModulAuspList[i] == this.modulPrWertFilter.idModul
      ) {
        userGebaeudeFilter!.wertAuspBisList[i] = this.selectValueBisFormControl.value;
        userGebaeudeFilter!.wertAuspVonList[i] = this.selectValueVonFormControl.value;
        found = true;
        break;
      }
    }

    if (!found) {
      userGebaeudeFilter!.idModulAuspList.push(this.modulPrWertFilter.idModul);

      userGebaeudeFilter!.wertAuspBisList.push(this.selectValueBisFormControl.value);
      userGebaeudeFilter!.wertAuspVonList.push(this.selectValueVonFormControl.value);
    }

    this.localService.userGebaeudeFilter.next(userGebaeudeFilter);
  }
}
